import { useEffect } from "react";
import api from "@/lib/appApi";

function injectHTML(target, html, tagId) {
  if (!html) return;
  const wrapper = document.createElement("div");
  wrapper.innerHTML = html;
  Array.from(wrapper.childNodes).forEach((node) => {
    if (node.tagName === "SCRIPT") {
      const s = document.createElement("script");
      Array.from(node.attributes).forEach((a) => s.setAttribute(a.name, a.value));
      s.text = node.textContent;
      s.setAttribute("data-injected", tagId);
      target.appendChild(s);
    } else {
      if (node.setAttribute) node.setAttribute("data-injected", tagId);
      target.appendChild(node);
    }
  });
}

export default function SiteCode() {
  useEffect(() => {
    document.querySelectorAll("[data-injected]").forEach((el) => el.remove());
    api.get("/site-code").then(({ data }) => {
      if (data.ga_id) {
        const g = document.createElement("script");
        g.async = true;
        g.src = `https://www.googletagmanager.com/gtag/js?id=${data.ga_id}`;
        g.setAttribute("data-injected", "ga");
        document.head.appendChild(g);
        const init = document.createElement("script");
        init.setAttribute("data-injected", "ga");
        init.text = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${data.ga_id}');`;
        document.head.appendChild(init);
      }
      if (data.search_console) {
        const m = document.createElement("meta");
        m.name = "google-site-verification";
        m.content = data.search_console;
        m.setAttribute("data-injected", "gsc");
        document.head.appendChild(m);
      }
      injectHTML(document.head, data.head_js, "head");
      injectHTML(document.body, data.body_js, "body");
    }).catch(() => {});
  }, []);
  return null;
}
